import { render, staticRenderFns } from "./Ayuda.vue?vue&type=template&id=29e0b92a&"
import script from "./Ayuda.vue?vue&type=script&lang=js&"
export * from "./Ayuda.vue?vue&type=script&lang=js&"
import style0 from "./Ayuda.vue?vue&type=style&index=0&id=29e0b92a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports